



























































































import {computed, defineComponent, getCurrentInstance, onMounted, reactive, ref} from '@vue/composition-api'
import request from '@/utils/request';
import PageWrapper from '@/components/PageWrapper/index.vue';
import waves from '@/directive/waves'
import Import from './import.vue';
import AddCart from "@/components/AddCart/index.vue";
import {Message} from "element-ui";

export default defineComponent({
  name: 'inventoryQuery',
  components: {AddCart, Import, PageWrapper},
  directives: {waves},
  setup() {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const searchFormRef = ref(null)
    const searchForm = reactive({
      xhname:'',
      xhname_ct:'',
      xhname_nct:'',
      source:'',
      gongyingshang:''
    })
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref("")
    const editFormData = ref({})
    const list = ref([])
    const listLoading = ref(false)
    const importLoading = ref(false)
    const keyId = ref(0)
    const submitLoading = ref(false)
    const dialogImport = ref(false)
    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })
    //获取海外查询列表
    const getInventory = () => {
      listLoading.value = false
      request({
        url: 'overseas_inventory_list.yy',
        method: 'post',
        params: selectPage,
        data: {...searchForm,username: username},
      }).then(res => {
        const {code, data, total,num} = res
        if (code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
          addedNum.value = num
        }
      })
    }

    onMounted(() => {
      getInventory()
    })

    //
    // const handleAdd = () => {
    //   dialog.value = true;
    //   type.value = "add";
    //   editFormData.value = {}
    // }
    //分页
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getInventory()

    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getInventory()
    }

    //编辑
    const handleEdit = (scope) => {
      dialogImport.value = true
      type.value = "edit"
      editFormData.value = {...editFormData.value, ...scope.row}
      keyId.value = scope.row.id
    }

    //新增和编辑提交
    const handleSubmit = (form:any) => {
      let data:any
      submitLoading.value = true
      if (type.value === 'add') {
        data = request({
          url: 'overseas_inventory_insert.yy',
          method: 'post',
          data: form
        })
      } else {
        data = request({
          url: 'overseas_inventory_edit.yy',
          method: 'post',
          data: {id: keyId.value, ...form}
        })
      }
      data.then(res => {
        if (res.code == 200) {
          submitLoading.value = false
          dialogImport.value = false
          getInventory()
        }
      })
    }
   //新增/编辑弹窗关闭
    const handleClose = () => {
      dialogImport.value = false
      editFormData.value = {}
    }
    //删除
    const handleDelete = (scope, index) => {
      request({
        url: 'overseas_inventory_delete.yy',
        method: 'post',
        data: {id: scope.row.id}
      }).then(res => {
        if (res.code == 200) deleteRow(index)
      })
    }

    const deleteRow = (index) => list.value.splice(index, 1)

    //导入
    const handleImport = () => {
      dialogImport.value = true
      type.value = "add";
      editFormData.value = {}
    }

    //导入弹窗关闭
    const handleImportClose = () => {
      dialogImport.value = false
    }
    //上传关闭
    const handleUpload = () => {
      dialogImport.value = false
      getInventory()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }
    //搜索
    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getInventory()
    }
    //重置
    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getInventory()
    }
    //添加功能
    const addedData = ref([])//已添加的数据
    const addedNum = ref(0)//已添加条数
    const drawerVisible = ref(false) //控制已添加数据弹窗
    //列表每行添加数据
    const handleAddXname = () => {
      drawerVisible.value = true
      request({
        url: 'member_add_cart.yy',
        method: 'post',
        data: {
          channel:2,
          username: username
        }
      }).then(res => {
        addedData.value = res.cartlist
      })
    }

    const disabledIndexes = ref([])//添加完按钮禁用
    //已添加列表展disabledIndexes示
    const addToDrawer = (row, channel, index: number) => {
      if (!disabledIndexes.value.includes(row.id)) {
        disabledIndexes.value.push(row.id);
      }
      drawerVisible.value = true
      request({
        url: 'member_add_cart.yy',
        method: 'post',
        data: {
          id: row.id,
          username: username,
          channel: channel   //type 1 库存商品  2 数据列表
        }
      }).then(res => {
        const {code, msg} = res
        addedData.value = res.cartlist
        if (code == 200) {
          Message.success(msg)
        } else if (code == 300) {
          Message.warning(msg)
        } else if (code == 400) {
          Message.error(msg)
        }
      })
    }
   //购物车关闭
    const handleCloseAddCart = () => {
      drawerVisible.value = false
    }

    //购物车单个删除
    const removeFromDrawer = (id: number) => {
      disabledIndexes.value = disabledIndexes.value.filter(item => item !== id);
      getInventory()
    }
    //全部删除
    const handleClear = (items: Array<{ id: number }>) => {
      const ids = items.map(item => item.id);
      disabledIndexes.value = disabledIndexes.value.filter(item => !ids.includes(item))
      addedData.value = []
      addedNum.value = 0
    }
    return {
      disabledIndexes,
      addedData,
      addedNum,
      drawerVisible,
      dialogImport,
      keyId,
      list,
      searchForm,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      importLoading,
      listLoading,
      searchFormRef,
      submitLoading,
      handleClear,
      removeFromDrawer,
      handleCloseAddCart,
      addToDrawer,
      handleAddXname,
      closeSearch,
      handleSearchBtn,
      handleResetBtn,
      handleUpload,
      handleImportClose,
      handleImport,
      // handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      handleClose,
      handleEdit,
      handleDelete,
      deleteRow,
    };
  }
})
